var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    { staticClass: "boss-table-data", attrs: { rowspan: _vm.rowspan } },
    [
      _vm._l(_vm.photoclipIds, function (id, i) {
        return _c(
          "div",
          {
            key: "photoclip-" + i,
            staticClass: "pega-mb-05",
            attrs: { "data-test": "photoclip-preview-button" },
          },
          [
            _c(
              "button",
              {
                staticClass: "boss-button",
                attrs: { "data-test": "photoclip-preview-button-" + i },
                on: {
                  click: function ($event) {
                    return _vm.windowOpenPreview(
                      "photoClipPrePublishedPreview",
                      id
                    )
                  },
                },
              },
              [_vm._v("\n      フォトクリップ\n    ")]
            ),
          ]
        )
      }),
      _vm._v(" "),
      _vm._l(_vm.interviewIds, function (id, i) {
        return _c(
          "div",
          {
            key: "interview-" + i,
            staticClass: "pega-mt-05",
            attrs: { "data-test": "interview-preview-button" },
          },
          [
            _c(
              "button",
              {
                staticClass: "boss-button",
                attrs: { "data-test": "interview-preview-button-" + i },
                on: {
                  click: function ($event) {
                    return _vm.windowOpenPreview(
                      "interviewPrePublishedPreview",
                      id
                    )
                  },
                },
              },
              [_vm._v("\n      インタビュー\n    ")]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }